import React from 'react';
import {Modal, Typography} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {AnimatedContainer, MessageContainer, StyledSpin} from './SelfRegistrationStyled';
import {PulsingCircle} from "./SelfRegistrationStyled";

const {Text} = Typography;

interface PaymentStatusModalProps {
    open: boolean;
}

interface PaymentStatusModalProps {
    fspType?: any
}

export const PaymentStatusModal: React.FC<PaymentStatusModalProps> = ({open, fspType}) => {
    return (
        <Modal
            open={open}
            footer={null}
            closable={false}
            centered
        >
            <AnimatedContainer>
                <PulsingCircle>
                    <StyledSpin indicator={<LoadingOutlined style={{fontSize: 24}} spin/>}/>
                </PulsingCircle>
                <MessageContainer>
                    <Text strong className="text-lg mb-4">
                        Processing Your Payment
                    </Text>
                    <Text className="block mb-2">
                        Please respond to the payment prompt on your phone.
                    </Text>
                    <Text className="block mb-2">
                        This usually takes less than a minute.
                    </Text>
                    <Text className="block text-sm text-gray-500">
                        Please don't close this window or refresh the page.
                    </Text>
                </MessageContainer>
            </AnimatedContainer>
        </Modal>
    );
};

